import { FormFactorConstants } from '../common/formFactor.constants'
import { isTablet } from './isTablet.util'

export const getFormFactor = (): string => {
  return isTablet() ? FormFactorConstants.TABLET : FormFactorConstants.MOBILE
}
